function getQueryParameters(url) {
  const searchParams = url ? new URL(url).searchParams : new URLSearchParams(window.location.search);
  const params = {};
  searchParams.forEach((value, key) => params[key] = value);
  return params;
}
export {
  getQueryParameters as default
};
